import { combineReducers } from 'redux';

import blockMatrixReducer from './intermodalYardPlanning/blockMatrix';

export default () =>
  combineReducers({
    blockMatrix: blockMatrixReducer
  });
